import { render } from "./gzhArticleList.vue?vue&type=template&id=20e4631c"
import script from "./gzhArticleList.vue?vue&type=script&lang=js"
export * from "./gzhArticleList.vue?vue&type=script&lang=js"

import "./gzhArticleList.vue?vue&type=style&index=0&id=20e4631c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__